import React from 'react';

interface PageVictoryProps {
  onRequestClose?: () => void;
  combinationsCount: number;
  themeName: string;
  totalTerms: number;
}

export const PageVictory: React.FC<PageVictoryProps> = ({
  onRequestClose,
  combinationsCount,
  themeName,
  totalTerms,
}) => {
  return (
    <div
      style={{
        padding: '8px 4px 24px',
        color: '#e2e8f0',
        maxWidth: 380,
        margin: '0 auto',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 56, marginBottom: 8 }}>🏆</div>

      <h2
        style={{
          fontFamily: 'cubano, sans-serif',
          fontSize: 28,
          color: '#a5b4fc',
          margin: '0 0 8px',
        }}
      >
        All constellations complete!
      </h2>

      <p style={{ fontSize: 14, color: '#94a3b8', margin: '0 0 24px' }}>
        You discovered all {totalTerms} terms in today's{' '}
        <strong style={{ color: '#c7d2fe' }}>{themeName}</strong> theme.
      </p>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 32,
          marginBottom: 28,
        }}
      >
        <Stat label="Combinations" value={String(combinationsCount)} />
        <Stat label="Terms found" value={String(totalTerms)} />
      </div>

      <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 20 }}>
        Come back tomorrow for a new theme!
      </p>

      <button
        onClick={onRequestClose}
        style={{
          width: '100%',
          padding: 14,
          borderRadius: 12,
          border: 'none',
          background: '#6366f1',
          color: '#fff',
          fontSize: 16,
          fontWeight: 700,
          cursor: 'pointer',
          fontFamily: 'cubano, sans-serif',
          letterSpacing: '0.03em',
        }}
      >
        Back to Board
      </button>
    </div>
  );
};

const Stat: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
    <span style={{ fontSize: 28, fontWeight: 700, color: '#e2e8f0', fontFamily: 'cubano, sans-serif' }}>
      {value}
    </span>
    <span style={{ fontSize: 12, color: '#6b7280' }}>{label}</span>
  </div>
);
